import getConfig from 'next/config';

import { BalanceSchema } from 'types/Balance';

export default async function getBalance(): Promise<BalanceSchema | undefined> {
  const { publicRuntimeConfig } = getConfig();
  const response = await fetch<'api'>(
    `${publicRuntimeConfig.bcom.baseUrl}/api/v1/member/me/balance/`,
  );

  if (!response.ok) {
    return undefined;
  }

  return await response.json();
}
